import React from 'react';
import CreateVersionModalState from '../Modals/CreateVersionModal/CreateVersionModalState';
import Modal from '../Modal/Modal';
import FormGroup from '../FormGroup/FormGroup';

interface Props {
    onSaveClick: (name: string, comment: string) => void;
    defaultName: string;
    defaultComment: string;
    onClose?: () => void;
    title?: string;
}

class ChangeLogNameAndCommentModal extends React.Component<Props, CreateVersionModalState> {

    constructor(props: any) {
        super(props);

        this.state = {
            title: this.props.title || '',
            isOpen: true,
            error: null,
            name: this.props.defaultName,
            comment: this.props.defaultComment,
            onSaveClick: null as any
        };

        this.onNameChange = this.onNameChange.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.close = this.close.bind(this);
    }
    onNameChange(e: React.ChangeEvent<HTMLInputElement>): void {

        let changes = { name: e.target.value } as CreateVersionModalState;

        this.setState(changes);
    }

    onCommentChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {

        let changes = { comment: e.target.value } as CreateVersionModalState;

        this.setState(changes);
    }

    onSaveClick(): void {

        this.props.onSaveClick(this.state.name, this.state.comment);
        this.setState({ isOpen: false });
    }

    close(): void {
        this.setState({ isOpen: false });

        this.props.onClose && this.props.onClose();
    }

    render(): JSX.Element {
        const labelClass = 'col-3';
        const contentClass = 'col-9';

        return (
            <Modal state={this.state} close={this.close}>

                <FormGroup label="Name:" labelClassName={labelClass} contentClassName={contentClass}>
                    <input
                        type="text"
                        className="form-control"
                        value={this.state.name}
                        onChange={this.onNameChange} />
                </FormGroup>

                <FormGroup label="Comment:" labelClassName={labelClass} contentClassName={contentClass}>
                    <textarea
                        className="form-control"
                        onChange={this.onCommentChange}
                        value={this.state.comment}>
                    </textarea>
                </FormGroup>

                <button className="btn cb-btn" onClick={this.onSaveClick}>Save</button>
            </Modal>
        )
    }
}

export default ChangeLogNameAndCommentModal;
